import type { RouteObject } from 'react-router-dom';
import { createBrowserRouter, Navigate } from 'react-router-dom';

import { ApiTokenInitializer } from './components/api-provider';
import { AdminRoute } from './components/auth/admin-route';
import { ProtectedRoute } from './components/protected-route';
import { RootRedirect } from './components/root-redirect';
import { AppLayout } from './layouts/app-layout';
import { AdminPlans } from './pages/admin-plans';
import { AdminUsers } from './pages/admin-users';
import { NotFound } from './pages/not-found';
import { ProjectEdit } from './pages/project-edit';
import { ProjectList } from './pages/project-list';
import { ProjectRehearse } from './pages/project-rehearse';
import { SignInPage } from './pages/sign-in';
import { SignUpPage } from './pages/sign-up';

export const routes: RouteObject[] = [
  { index: true, element: <RootRedirect /> },
  { path: 'sign-in/*', element: <SignInPage /> },
  { path: 'sign-up/*', element: <SignUpPage /> },
  {
    path: 'app/projects/:id/rehearse',
    element: (
      <ProtectedRoute>
        <ApiTokenInitializer>
          <ProjectRehearse />
        </ApiTokenInitializer>
      </ProtectedRoute>
    ),
  },
  {
    path: 'app',
    element: (
      <ProtectedRoute>
        <ApiTokenInitializer>
          <AppLayout />
        </ApiTokenInitializer>
      </ProtectedRoute>
    ),
    children: [
      { index: true, element: <Navigate to="projects" replace /> },
      { path: 'projects', element: <ProjectList /> },
      { path: 'projects/:id/edit', element: <ProjectEdit /> },
      {
        path: 'admin/plans',
        element: (
          <AdminRoute>
            <AdminPlans />
          </AdminRoute>
        ),
      },
      {
        path: 'admin/users',
        element: (
          <AdminRoute>
            <AdminUsers />
          </AdminRoute>
        ),
      },
    ],
  },
  { path: '*', element: <NotFound /> },
];

export const router = createBrowserRouter(routes);
